import React from "react";
import { useTranslation } from "@helpers/translate";
import EyeIcon from "@assets/icons/EyeIcon";

/**
 * @param {object} props
 * @param {() => void} props.onPlaceTrade
 * @param {boolean} props.isPlacingTrade
 * @param {boolean} props.isDisabled
 * @param {string} props.mutedColor
 * @param {() => void} props.onFeesClick
 */
export const TradeFooter = ({
  onPlaceTrade,
  isPlacingTrade,
  isDisabled = false,
  mutedColor,
  onFeesClick,
}) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-form__footer">
      <button
        type="button"
        className="trade-form__fees-row trade-form__fees-row--button"
        onClick={onFeesClick}
      >
        <span className="trade-form__fees">{__("futures.trade_form.view_fees")}</span>
        <EyeIcon size={16} color={mutedColor} />
      </button>

      <button
        type="button"
        className={`trade-form__submit${isPlacingTrade ? " trade-form__submit--loading" : ""}`}
        data-futures-guide="open-position"
        onClick={onPlaceTrade}
        disabled={isPlacingTrade || isDisabled}
      >
        {isPlacingTrade
          ? __("futures.mobile_trade.placing")
          : __("futures.mobile_trade.place_trade")}
      </button>
    </div>
  );
};
